<script setup lang="ts">
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'

  interface Props {
    locale?: string
    disabled?: boolean
  }

  withDefaults(defineProps<Props>(), {
    locale: 'en',
  })
</script>

<template>
  <WrapperQC
    gap="var(--spacing-3)"
    class="back-button-qc"
    :class="{ 'back-button-qc--disabled': disabled }"
  >
    <IconQC
      class="back-button-qc__icon"
      :name="`arrow-narrow-${locale === 'en' ? 'left' : 'right'}`"
    />
    <span class="text-small-medium">{{ $t('travel.common.back.button') }}</span>
  </WrapperQC>
</template>

<style lang="scss" scoped>
  .back-button-qc {
    cursor: pointer;
    align-items: center;
    color: var(--colorTxtSrfSecondary);
    transition: all 0.2s ease;
    width: fit-content;

    & * {
      transition: all 0.2s ease;
    }

    :deep(.back-button-qc__icon) {
      path {
        fill: var(--colorIcnSrfSecondary);
      }
    }

    &:hover,
    &:active {
      color: var(--colorTxtSrfPrimary);

      :deep(.back-button-qc__icon) {
        path {
          fill: var(--colorIcnSrfPrimary);
        }
      }
    }
  }

  .back-button-qc--disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
</style>
